import PropTypes from 'prop-types';
import React from 'react';

import TopBar from '../../Modules/TopBar/TopBar';
import { ellipsify } from '../../../../../utilities/helperFunctions';

import './DropdownLayout.scss';

export default class DropdownLayout extends React.PureComponent {
    static propTypes = {
        /**
         * any element to be rendered underneath topbar
         */
        children: PropTypes.element.isRequired,
        /**
         * custom css class for easier styling
         */
        cssClass: PropTypes.string,
        /**
         * either heading text or username
         */
        headerText: PropTypes.string,
        /**
         * function to handle closing of dropdown
         */
        onClose: PropTypes.func.isRequired,
        /**
         * optional, string of user's logo or default avatar image
         */
        profileImage: PropTypes.string,
        /**
         * boolean to check whether dropdown should render
         */
        shouldShowDropdown: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        cssClass: '',
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    setWrapperRef = (node) => (this.wrapperRef = node);

    handleClickOutside = (event) => {
        if (
            this.props.shouldShowDropdown &&
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target)
        ) {
            this.props.onClose();
        }
    };

    render() {
        const { headerText } = this.props;

        const truncatedDisplayName = ellipsify(headerText, 16);

        return (
            <div
                className={`component-Layout-Header-Layout-DropdownLayout ${this.props.cssClass}`}
            >
                <div ref={this.setWrapperRef}>
                    <TopBar
                        handleClose={this.props.onClose}
                        headerText={truncatedDisplayName}
                        profileImage={this.props.profileImage}
                    />
                    {this.props.children}
                </div>
            </div>
        );
    }
}
